import styles from "./card-info.module.css";

const cardClasses = {
  "one-column": styles["card-one-column"],
  "two-columns": styles["card-two-columns"],
};

export const generateCardClasses = (
  variation: "one-column" | "two-columns",
) => {
  return `${styles.card} ${cardClasses[variation]}`;
};
